<template>
  <modal ref="modal" @close="onClose">
    <template slot="title">Export MailPublisher</template>
    <template slot="name">MailPublisherにエクスポート（今月残り {{ limitedRemainingCount }}/{{ maxCount }}）</template>
    <template slot="input">
      <div class="input-wrapper">
        <textarea
          v-model="comment"
          :disabled="!isSubmitComment"
          :class="{disabled: !isSubmitComment}"
        />
        <label>
          <input
            type="checkbox"
            :checked="isSubmitComment"
            v-model="isSubmitComment"
          />
          メモを下書きコメント欄に反映(最大256文字)
        </label>
        <span v-if="isSubmitComment && !validateCommentLength" class="error-message">メモが長すぎます</span>
      </div>
    </template>
    <template slot="submit">
      <button v-if="validate" type="button" @click="onSubmit" class="submit normal-btn">送信</button>
      <button v-else type="button" disabled class="submit normal-btn">送信</button>
    </template>
  </modal>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'
import modal from '@/components/Util/Modal'
import constants from '@/constants'

export default {
  name: 'export-mp',
  mixins: [ base ],
  data () {
    return {
      comment: '',
      isSubmitComment: true,
      rawHTML: '',
      mobileCSS: '',
      maxCount: 0,
      currentCount: 0,
      isLoading: false,
    }
  },
  components: {
    modal
  },
  created () {
    this.initRateLimit()
    this.initComment()
  },
  methods: {
    async initRateLimit () {
      await this.$http({
        url: '/plan/rate_limit',
        type: 'GET',
      }).then((json) => {
        this.maxCount = json.data.plan.mp_and_zip_export_max_count
        this.currentCount = json.data.using.mp_and_zip_export_max_count
      })
    },
    initComment () {
      this.comment = this.$store.getters.getContentInfoMpComment
    },
    onClose () {
      this.$emit('close')
    },
    async onSubmit () {
      this.isLoading = true
      // コードパーツ 未使用の画像を削除
      this.$store.commit('deleteCodePartUnUseImage', this.$store.getters.getSectionAll)
      const randContentId = this.$utils.string.generateRandContentId()
      const sections = await this.getReplacedUrlSections(randContentId, 'mp')
      if (!sections) return

      this.createRawHTML(sections)
      await this.getContentSize()
      const saveJson = await this.$store.dispatch('savePreviewData')
      if (!saveJson || saveJson.status !== 200) return

      // MPへエクスポートするHTMLメール
      this.createRawHTML(sections)
      this.mobileCSS = this.createMobileCSS()
      const formData = new FormData()
      formData.append('body', this.rawHTML)
      formData.append('contentId', this.$route.params.id)
      formData.append('randContentId', randContentId)
      // title
      formData.append('title', this.$store.getters.getContentInfo.name)
      // モバイルスタイルCSS
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      // メール用CSS
      formData.append('headCss', this.createHeadCSS())
      // outlook CSS
      formData.append('outlookCss', this.createOutlookCSS())
      // MP用コメント
      if (this.isSubmitComment) formData.append('mpComment', this.$utils.string.b64Encode(this.comment))
      await this.$http({
        type: 'POST',
        url: '/mp_content/save_draft',
        params: formData,
      })
      this.$emit('close')
    },
  },
  computed: {
    validateCommentLength () {
      return [...this.comment].length <= constants.maxContentInfoCommentLength
    },
    limitedRemainingCount () {
      const remainingCount = this.maxCount - this.currentCount
      return remainingCount <= 0 ? 0 : remainingCount
    },
    validate () {
      if (this.isSubmitComment) {
        return this.validateCommentLength && this.limitedRemainingCount > 0 && !this.isLoading
      }
      return this.limitedRemainingCount > 0 && !this.isLoading
    }
  },
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  margin: 10px 0;
  textarea {
    border: 1px solid #ccc;
    color: $commonFontColor;
    background: #FFF;
    border-radius: 2px;
    min-height: 100px;
    width: 100%;
    padding: 5px 10px;
    line-height: 1.5;
    box-sizing: border-box;
    &::-webkit-resizer {
      display: none;
    }
    &.disabled {
      pointer-events: none;
      opacity: 0.8;
      color: #ccc;
      input {
        color: #ccc;
      }
    }
  }
  label {
    display: block;
  }
}
.submit {
  font-size: 14px;
  border-radius: 5px;
  color: #fff;
  border: solid 1px #484848;
  background: #484848;
  &:hover {
    background: #484848;
    opacity: 0.8;
  }
  &:disabled {
    border: solid 1px #6c757d;
    background: #6c757d;
    opacity: 0.8;
    cursor: default;
  }
}
</style>
